import {api} from './_ApiFactoryWithHeader';

export const apiUsers = {
    getUserList: (params, cancelToken) => api.get('users', params, null, cancelToken),

    getUserDetail: (username, params) => api.get(`users/${encodeURIComponent(username)}`, params, null, null),

    createUser: (body) => {
        return api.post('users', body)
    },

    updateUser: (username, body) => {
        return api.put(`users/${encodeURIComponent(username)}`, body)
    },

    updateAccessRights: (body) => {
        return api.put(`access_rights_mass_update`, body)
    },

    uploadNewProfileImage(fileData) {
        return api.post('files', fileData)
    },

    deleteUser: (usernames) => {
        const searchParams = new URLSearchParams({
            'username[in]': usernames,
        });
        return api.delete(`users?${searchParams.toString()}}`, null, null, null)
    },

    changePassword: (username, body) => {
        return api.put(`change_password/${encodeURIComponent(username)}`, body)
    },
    changePasswordUser: (username, body) => {
        return api.put(`users/${encodeURIComponent(username)}/reset_password/`, body)
    },

    getClientDetails: (params) => {
        return api.get('user_profiles', params, null)
    },
    addClientDetail: (body) => {
        return api.post(`user_profiles`, body)
    },
    updateClientDetail: (id, body) => {
        return api.put(`user_profiles/${encodeURIComponent(id)}`, body)
    },
    getCreditHistories: (params) => {
        return api.get(`credit_histories`, params, null)
    },

    addCredit: (username, body) => {
        return api.post(`users/${encodeURIComponent(username)}/add_credit/`, body)
    },
    sendOneToOneMsg: (username, body) => {
        return api.post(`messages`, body)
    },

    getWechatMsgTemplates: (params) => {
        return api.get(`wechat_templates`, params, null)
    },
    sendWechatMsg: (wechatTemplateId, params) => {
        return api.get(`/wechat_templates/${encodeURIComponent(wechatTemplateId)}/send_message`, params, null)
    },
};
